import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules/create')({
  beforeLoad: () => getTitleContextSlice('Create Incident Rule'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
